import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { EarningsTitle, SubscripationTitle } from "../../../../../Constants/Constants";
import { H5 } from "../../../../../AbstractElements";
import ReactApexChart from "react-apexcharts";
import { EarningChart, SubscripationChart } from "../../../../../Data/General/Dashboard/Default";

const Earnings = () => {
  return (
    <Col xl="3" sm="6">
      <Row>
        <Col xl="12">
          <Card className="earning-chart">
            <DashboardCommonHeader title={EarningsTitle} dropdownClass="dropdown-toggle" />
            <CardBody className="pt-0">
              <H5 className="mt-2">$8,252</H5>
              <div id="earningChart">
                <ReactApexChart type="radialBar" options={EarningChart} series={EarningChart.series} height={200} />
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl="12">
          <Card className="earning-chart">
            <DashboardCommonHeader title={SubscripationTitle} dropdownClass="dropdown-toggle" />
            <CardBody className="py-0">
              <H5 className="mt-2">$2,249</H5>
              <div id="Subscripationchart" className="Subscripationchart">
                <ReactApexChart type="area" options={SubscripationChart} series={SubscripationChart.series} height={135} />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Col>
  );
};

export default Earnings;
